import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { RetailCompassStorage } from "@common/utils";
import { RecommendationsService } from "@common/data-access";
import { RECOMMENDATIONS_ALLOWED_USER_IDS } from "./allowedUsers";
import {
    RECOMMENDATION_CASES,
    RECOMMENDATION_MODULES,
    sortRecommendationCards,
} from "./recommendationCases";
import { RecommendationsBanner } from "./RecommendationsBanner";
import { RecommendationsExpanded } from "./RecommendationsExpanded";
import { RecommendationsPanel } from "./RecommendationsPanel";

export function RecommendationsSection() {
    const user = RetailCompassStorage.getUser();
    const userId = Number(user && user.id);

    if (!Number.isInteger(userId) || !RECOMMENDATIONS_ALLOWED_USER_IDS.includes(userId)) {
        return null;
    }

    return <RecommendationsSectionContent userId={userId} />;
}

function RecommendationsSectionContent({ userId }) {
    const storeId = RetailCompassStorage.getStoreId();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [expanded, setExpanded] = useState(false);
    const [selectedCase, setSelectedCase] = useState(null);

    useEffect(() => {
        if (!storeId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        RecommendationsService.fetchRecommendations({
            userId,
            storeId,
            module: RECOMMENDATION_MODULES.MARKET,
        })
            .then((response) => {
                if (cancelled) return;
                setData(response);
                setIsLoading(false);
            })
            .catch(() => {
                if (cancelled) return;
                setData(null);
                setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [userId, storeId]);

    if (isLoading) {
        return (
            <div
                className="recommendations-section recommendations-section--loading"
                data-testid="recommendations-loading">
                <CircularProgress size={20} />
                <span>Buscando oportunidades para tus productos…</span>
            </div>
        );
    }

    if (!data || !data.supported) return null;

    const knownCards = data.cards.filter((card) => RECOMMENDATION_CASES[card.case]);
    if (knownCards.length === 0) return null;

    const cards = sortRecommendationCards(knownCards);

    return (
        <section className="recommendations-section">
            {expanded ? (
                <RecommendationsExpanded
                    cards={cards}
                    onCollapse={() => setExpanded(false)}
                    onOpenCase={setSelectedCase}
                />
            ) : (
                <RecommendationsBanner
                    cards={cards}
                    summaryBanner={data.summaryBanner}
                    onExpand={() => setExpanded(true)}
                />
            )}

            <RecommendationsPanel
                cards={cards}
                selectedCase={selectedCase}
                onSelectCase={setSelectedCase}
                onClose={() => setSelectedCase(null)}
            />
        </section>
    );
}
